/**
 * @file  News
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React from 'react';
import {Navigation} from '@yunying/crow';
// eslint-disable-next-line import/extensions
import routes from '~/route.config';

import './index.less';

function News(props) {
    const {children} = props;

    return (
        <div className="news-content">
            <Navigation dataSource={
                routes[0].subRoutes.find(item => item.name === 'news').subRoutes
                    .filter(item => (item.path !== 'detail/:id'))
                    .map((item, index) => ({
                        title: item.title,
                        key: index,
                        path: `/news/${item.path}`
                    }))
            }
            />
            {children}
        </div>
    );
}

export default News;
